<template>
  <div class="about">
    <h1>Locations</h1>
    <SearchBox @onSearch="onSearch" />

    <b-button size="lg" :to="{ name: 'addLocation' }">Add</b-button>
    <!-- <router-link tag="button" :to="{ name: 'addLocation' }">Add</router-link> -->
    <div>
      <b-alert :show="showMsg" dismissible fade @dismissed="showMsg = !showMsg"
        >No results match your search</b-alert
      >
    </div>

    <table class="table" v-show="result.length && !showMsg">
      <thead>
        <tr>
          <th scope="col">&nbsp;</th>
          <th scope="col">Name</th>
          <th scope="col">PIN Code</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in result" :key="item.id">
          <td>
            <router-link :to="{ name: 'editLocation', params: { id: item.id } }"
              >Edit</router-link
            >
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.passCode }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SearchBox from "@/components/SearchBox.vue";

export default {
  name: "locations",
  data: () => ({
    result: [],
    showMsg: false
  }),
  components: {
    SearchBox
  },
  methods: {
    onSearch(results) {
      console.log(results);
      this.result = results;
      this.showMsg = !this.result.length ? true : false;
    }
  }
};
</script>
